import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";
import Card from "./components/Card";
import Button from "./components/Button";
import HeaderButton from "./components/HeaderButton";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Loader from "./components/Loader";

const itemArray = [];

function App() {

    const [currentItems, setCurrentItems] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const fetchData = async () => {
        console.log("isFetching", isFetching)
        setIsLoading(true);
         await axios.get(process.env.REACT_APP_BACKEND_SERVER_URL + process.env.REACT_APP_FETCH_VIDEOS_URL)
         .then(res => {
            console.log("Fetched Data", res.data)
            const fetchedData = res.data;
            setCurrentItems([...itemArray, ...fetchedData]);
            setIsFetching(false);
            setIsLoading(false);
         })
         .catch(error => {
            setIsLoading(false);
            console.log("Fetched Data", error)
         })
         .finally(()=> {
            setIsLoading(false);
          });
        

    };

    useEffect(() => {
        console.log("UseEffect")
        fetchData();
    }, []);

    const handleSeemore = async (e) => {
        console.log("SeeMore")
        setIsFetching(true);
        fetchData()
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
            <Header />
            <Link to="/import">
                <HeaderButton name={"Import"}/>
            </Link>
            <main className="flex flex-col items-center justify-center flex-1 w-full px-4 relative">
                {currentItems.length < 1 ? <p> No videos. Click Import button to import and stream videos </p>
                    :
                    <>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
                            {currentItems.map((item) => (
                                <Card key={item.id} item={item} />
                            ))}
                        </div>
                        <div className="flex flex-col items-center justify-center flex-1 relative">
                            <Button
                                onClick={handleSeemore}
                            >
                                {isFetching ? "Loading..." : "See More"}
                            </Button>
                        </div>
                    </>

                }
            </main>
            {isLoading && <Loader />}
            <Footer />
        </div>
    )
}

export default App